export default __webpack_public_path__ + "static/media/facebook-logo.ff34b662.svg";